import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Drawer from "@material-ui/core/Drawer";
import { Scrollbar } from "@codeArt/components/Scrollbar";
import { getHelpIcon, parseHelp } from "./Help";
import { runtime, Util } from "@codeArt/common";
import { createIcon } from "@codeArt/components/common";
import { Box, Divider } from "@material-ui/core";
import { clone, type } from "@codeArt/utils/common";
import { HelpLink } from "./button/link";
import Switch from "./input/Switch";

export class SearchBar extends React.Component {
  //与SemiT结合使用的搜索栏

  constructor(props) {
    super(props);
    this.state = {
      value: ""
    };
  }

  field() {
    return this.props.field;
  }

  get() {
    return this.value;
  }

  onChange(e) {
    var value = e.target.value;
    this.setState({ value });
    this.value = value;
    let { onChange } = this.props;
    if (onChange) onChange();
  }

  render() {
    let { placeholder } = this.props;
    return (
      <div className="search-bar right-side-icon bg-transparent d-none d-sm-block">
        <div className="form-group">
          <input
            className="form-control border-0"
            type="search"
            placeholder={placeholder}
            onChange={this.onChange.bind(this)}
          />
          <button className="search-icon">
            <i className="zmdi zmdi-search zmdi-hc-lg" />
          </button>
        </div>
      </div>
    );
  }
}

export class SemiTPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      drawerState: false
    };
  }

  sideBar = drawer => {
    let { title, icon, side } = this.props;
    if (drawer) {
      return (
        <div className="module-side">
          <div className="module-side-content c-flex-1">{side}</div>
        </div>
      );
    }
    return (
      <div className="module-side">
        <div className="module-side-header">
          <div className="module-logo">
            {icon ? createIcon(icon, "c-icon-s3") : null}
            <span className={`c-text-s3 ${icon ? "pl-2" : ""}`}>{title}</span>
          </div>
        </div>
        <div className="module-side-content c-flex-1">
          <Scrollbar className="module-side-scroll scrollbar h-100">
            {side}
          </Scrollbar>
        </div>
      </div>
    );
  };

  onToggleDrawer() {
    this.setState({
      drawerState: !this.state.drawerState
    });
  }

  render() {
    let { header, children, drawerBtn } = this.props;
    return (
      <div
        className="app-module c-m-0 h-100 c-semiTPanel"
        style={{ paddingBottom: runtime.pc ? 1 : 0 }}
      >
        <div className="d-block d-xl-none">
          <Drawer
            open={this.state.drawerState}
            onClose={this.onToggleDrawer.bind(this)}
          >
            {this.sideBar(true)}
          </Drawer>
        </div>
        <div className="app-module-sidenav d-none d-xl-flex">
          {this.sideBar()}
        </div>
        <div className="module-box bg-white">
          <div className="module-box-header">
            {drawerBtn || (
              <IconButton
                className="drawer-btn d-block d-xl-none"
                aria-label="Menu"
                onClick={this.onToggleDrawer.bind(this)}
              >
                <i className="zmdi zmdi-menu" />
              </IconButton>
            )}
            {header}
          </div>
          <div className="module-box-content c-flex-1">
            {
              <Scrollbar className="module-side-scroll scrollbar h-100">
                {children}
              </Scrollbar>
            }
          </div>
        </div>
      </div>
    );
  }
}

export class Grid extends React.Component {
  render() {
    let { children, className } = this.props;
    return (
      <Box className={`c-grid ${className}`} display="flex" flexWrap="wrap">
        {children}
      </Box>
    );
  }
}

Grid.defaultProps = {
  className: "my-3"
};

Grid.modalProps = {
  //在窗口下，一般Grid会与Portal结合使用，因此不需要my-0
  className: "my-0"
};

export class GridCell extends React.Component {
  label(className) {
    let { label, labelClassName, labelWidth, layout, align } = this.props;
    if (layout == "half") labelWidth = "50%";
    return label ? (
      <div
        style={{ width: labelWidth }}
        className={`d-flex align-items-${align} text-grey mb-0 flex-nowrap ${className} ${labelClassName}`}
      >
        {label}
      </div>
    ) : null;
  }

  renderHelp() { }

  content() {
    let { has, content, right, layout, align, wrap, help, contentClassName } = this.props;
    if (align === "top") align = "start";
    else if (align === "bottom") align = "end";
    let contentStyle = {};
    if (layout === "near") contentStyle.flex = 1;
    return (
      <div className="d-flex flex-row justify-content-between c-flex-1">
        <div
          className={`d-flex flex-row  c-flex-1 justify-content-${layout ==
            "between"
            ? "between"
            : "start"}`}
        >
          {wrap ? null : this.label("mr-2")}
          <div
            className={`d-flex align-items-${align} text-${has
              ? "dark"
              : "grey"} c-text-s1d5 mb-0 ${contentClassName}`}
            style={contentStyle}
          >
            {content}
          </div>
        </div>
        {right || help ? (
          <div className="d-flex flex-row justify-content-center align-items-start ml-2">
            {right ? right : null}
            {help ? getHelpIcon(help, { className: "ml-3" }) : null}
          </div>
        ) : null}
      </div>
    );
  }

  getSizeClassName() {
    let { size } = this.props;
    return getSizeClassName(size);
  }

  tryLeft(main) {
    let { left } = this.props;
    if (!left) return main;
    return (
      <div className="d-flex flex-row">
        <div className="d-flex flex-column">{left}</div>
        <div className="d-flex flex-column c-flex-1">{main}</div>
      </div>
    );
  }

  render() {
    let {
      line,
      className,
      slim,
      average,
      children,
      wrap,
      onClick,
      layout,
      labelWidth
    } = this.props;
    if (layout === "single")
      return (
        <SingleGridCell
          {...this.props}
          labelWidth={
            labelWidth === "auto" || !labelWidth ? "7rem" : labelWidth
          }
        />
      );
    let containerClassName = "pt-3 pb-1 pt-sm-4 pb-sm-2";
    if (slim) containerClassName = "pt-2 pb-1 pt-sm-3 pb-sm-1";
    if (average) containerClassName = "c-pt-1d5 c-pb-1d5";
    let p = {};
    if (onClick)
      p.onClick = e => {
        onClick(e);
      };
    return (
      <div className={`col-12 ${this.getSizeClassName()} ${onClick ? "c-pointer" : ""} d-flex flex-column ${containerClassName} ${className}`} {...p}>
        {this.tryLeft(
          <React.Fragment>
            {wrap ? this.label("mb-2") : null}
            {children || this.content()}
            {line ? <div className="mt-2 pb-2 c-lt w-100" /> : null}
          </React.Fragment>
        )}
      </div>
    );
  }
}

GridCell.defaultProps = {
  line: true,
  has: false,
  contentClassName: "",
  labelClassName: "c-text-s1d5",
  className: "",
  slim: false,
  wrap: false,
  layout: "near", //near,between,half
  align: "center", //垂直的对齐方式
  labelWidth: "auto",
  size: 12
};

class SingleGridCell extends React.Component {
  label() {
    let { label, labelClassName, labelWidth, className } = this.props;
    if (!label) return;
    return (
      <div className={`d-flex flex-column justify-content-start align-items-center  mr-2`}>
        <div
          style={{ width: labelWidth }}
          className={`text-grey ${labelClassName} c-py-3d5 mb-0 flex-nowrap`}
        >
          {label}
        </div>
      </div>
    );
  }

  content() {
    let { has, content, right, help, line, contentClassName } = this.props;
    return (
      <div
        className={`d-flex flex-row justify-content-between align-items-center ${line
          ? "c-lb"
          : ""} c-flex-1 ${contentClassName || 'c-py-3d5'}`}
      >
        <div
          className={`d-flex flex-column c-flex-1 justify-content-center align-items-start text-${has
            ? "dark"
            : "grey"} c-text-s1d5 mb-0`}
        >
          {content}
        </div>
        {right || help ? (
          <div className="d-flex flex-row jutify-content-center align-items-center ml-3">
            {right ? right : null}
            {help ? getHelpIcon(help, { className: "ml-2" }) : null}
          </div>
        ) : null}
      </div>
    );
  }

  render() {
    let { line, className, size, onClick } = this.props;
    return (
      <div className={`col-12 ${getSizeClassName(size)} d-flex flex-row justify-content-start align-items-start ${className}`}>
        {this.label()}
        {this.content()}
      </div>
    );
  }
}

export function getSizeClassName(size) {
  if (type(size) === "object") {
    let l = ["col-12"];
    for (let e in size) {
      l.push(`col-${e}-${size[e]}`);
    }
    return l.join(' ');
  }
  return `col-md-${size}`;
}

export class GridSection extends React.Component {
  render() {
    let { title, className, textClassName, help, tools } = this.props;
    help = parseHelp(help);
    return (
      <Box
        className={`c-gridSection d-flex flex-row justify-content-between align-items-center w-100 ${className}`}
      >
        <div className="d-flex flex-column">
          {help.url ? (
            <div className={`mb-0 font-weight-bold ${textClassName}`}>
              {title}
              <HelpLink className="ml-1" href={help.url} />
            </div>
          ) : (
            <p className={`mb-0 font-weight-bold ${textClassName}`}>{title}</p>
          )}
          {help.message ? (
            <p className={`c-text-s1 m-text-muted mb-0`}>{help.message}</p>
          ) : null}
        </div>
        {tools ? <div>{tools}</div> : null}
      </Box>
    );
  }
}

GridSection.defaultProps = {
  title: "",
  className: "mb-0 mt-4",
  textClassName: "c-text-s1d5 m-text-dark75"
};

GridSection.groupProps = {
  className: "mt-2 mb-1",
  textClassName: "c-text-s2"
}

const GridPanel = ({ title, cellSize, children }) => {
  if (!children || children.length === 0) return null;
  let t = children.map ? children : [children];
  return (
    <div className="d-flex w-100">
      <div className="row c-flex-1">
        {title ? <div className="col-12"><GridSection title={title} {...GridSection.groupProps} /></div> : null}
        {t.map((cell, index) => {
          return (
            <div key={`cell-${index}`} className={`col-${cellSize}`}>
              {cell}
            </div>
          )
        })}
      </div>
    </div>
  );
}

const SwitchCell = ({ label, field, input, get, size = 12, className = '', onClick }) => {

  return (
    <GridCell
      className={`c-pt-2 ${className}`}
      size={size}
      layout={"between"}
      label={label}
      content={
        <Switch
          {...input(field)}
          className="c-mb-0"
          color="green"
          size="small"
          onClick={onClick}
        />
      }
      labelClassName={`c-text-s2 ${get(field) ? 'text-dark' : 'text-grey'}`}
    />
  );
}

const InputCell = ({ label, className, children, size = 12 }) => {

  return (
    <GridCell
      label={label}
      className={`c-py-2 ${className}`}
      contentClassName={"c-py-0 c-pb-2"}
      size={size}
      layout="single"
      content={children}
    />
  );
}

class VerticalCell extends React.Component {
  label() {
    let { label, labelClassName, tools } = this.props;
    return (
      <div className={`d-flex align-items-center justify-content-between text-dark mb-0 c-font-weight-bold ${labelClassName}`}>
        {label}

        {tools ? <div>{tools}</div> : null}
      </div>
    )
  }

  content() {
    let { has, content, contentStyle } = this.props;
    return (
      <div className={`d-flex flex-row  c-flex-1 justify-content-start c-flex-1`} >
        <div className={`d-flex align-items-start text-${has ? "dark" : "grey"} c-text-s1d5 mb-0`} style={contentStyle}>
          {content}
        </div>
      </div>
    );
  }

  getSizeClassName() {
    let { size } = this.props;
    return getSizeClassName(size);
  }

  render() {
    let { line, className, onClick, } = this.props;
    let containerClassName = "pt-3 pb-1 pt-sm-4 pb-sm-2";
    let p = {};
    if (onClick) p.onClick = e => { onClick(e); };

    return (
      <Box
        className={`d-flex flex-column ${containerClassName} ${className}`}
        {...p}
        {...this.getSizeClassName()}
      >
        {this.label()}
        {line ? <div className="mt-2 pb-2 c-lt w-100" /> : null}
        {this.content()}
      </Box>
    );
  }
}

VerticalCell.defaultProps = {
  line: true,
  has: false,
  labelClassName: "c-text-s1d5",
  className: "",
  size: 12
};


export { SwitchCell, InputCell, GridPanel, VerticalCell };